import constants from './constants';

const initState = {
  isLogged: false,
  username: null,
  first_name: null,
  last_name: null,
  email: null,
  clients: null,
  get_all_permissions: null,
  clientTarget: null,
  isFirstTime: false,
  userIdToEdit: {
    id: null,
    isAdmin: false,
  },
  newUser: {
    email: '',
    first_name: '',
    last_name: '',
    phone: '',
    birthdate: '',
    role: '',
    password: '',
    business_id: [],
    devices_id: [],
    clients_id: [],
  },
};

function userReducer(state = initState, { type, payload }) {

  switch (type) {

    case constants.SET_FIRST_TIME:
      return {
        ...state,
        isFirstTime: payload,
      };

    case constants.USER_UPDATE:
      return {
        ...state,
        ...payload,
        isLogged: true,
      };

    case constants.USER_SET_CLIENT:
      return {
        ...state,
        clientTarget: payload,
      };

    case constants.USER_CREATE_EDIT_USER:
      return {
        ...state,
        newUser: payload,
      };

    case constants.USER_EDIT_ID:
      return {
        ...state,
        userIdToEdit: payload,
      };

    default:
      return state;

  }

}

export default userReducer;
